
import React from "react";
const MarketPriceSectionRow = ({ children }) => (
    <div style={{
        display: 'flex',
        flexDirection: 'row',
        borderBottom: '1px solid lightgrey',
        width: '100%',
        alignItems:"baseline",
        justifyContent:"baseline"
    }}>
        {children}
    </div>
);
export default MarketPriceSectionRow;
